import * as Sentry from "@sentry/browser";
import type { SeverityLevel } from "@sentry/browser";

const severityLevels: SeverityLevel[] = [
  "fatal",
  "error",
  "warning",
  "log",
  "info",
  "debug",
];
export default class ErrorLogger {
  private _isScorm: boolean;
  private _host: string;
  private _host_url: string;

  constructor({ isScorm = false, disable = false }) {
    const App = window?.Application;
    // Skip if we are in a SCORM environment window is not always available
    if (!App || disable) return;

    this._isScorm = isScorm;
    Sentry.init({
      dsn: "https://e2a37712d446601052e96878edfedeec@o176876.ingest.us.sentry.io/5463951",
      release: `thomas-release-${__webpack_hash__ ?? "thomas-release-main"}`, // Webpack hash created at build time on deploy
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      enabled: process.env.NODE_ENV === "production",
      // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost"],

      // Performance Monitoring
      tracesSampleRate: 0.1, //  Capture 100% of the transactions
      environment: process.env.NODE_ENV,
      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });

    const params = new URLSearchParams(window.location.hash);
    this._host = !!params.get("cms")
      ? "lms"
      : !!params.get("public")
      ? "public preview"
      : "maggie";
    this._host_url =
      window.location != window.parent.location
        ? document.referrer
        : document.location.href;

    // Get current session
    const { Session } = App.actions();
    Session.get((err, data) => {
      console.log("session", data);

      Sentry.setContext("lesson", {
        lesson_id: data?.id ?? params.get("lesson_id"),
        host: this._host,
        host_url: this._host_url,
      });
    });
  }

  captureException<T extends Error, P extends {}>(error: T, extra?: P) {
    Sentry.captureException(error, {
      extra: {
        ...extra,
        isScorm: this._isScorm,
        host: this._host,
        host_url: this._host_url,
      },
    });
  }

  captureMessage<T extends {}>(
    message: string,
    level: SeverityLevel,
    extra: T
  ) {
    // Convert the level to something Sentry supports
    const severityLevel = severityLevels.find(
      (item) => item === (level as SeverityLevel)
    );
    Sentry.captureMessage(message, {
      extra: {
        ...extra,
        isScorm: this._isScorm,
        host: this._host,
        host_url: this._host_url,
      },
      level: severityLevel as any,
    });
  }
}

module.exports = ErrorLogger;
